// import { useEffect, useState } from 'react';
// import { Col, Collapse, Input, message, Popconfirm, Row, Select, Space, Table, Divider, Button, Card, DatePicker, Switch, Dropdown, Typography } from 'antd';
// import { dateFormat, menuLinks, notifyMessages, roleCode, tablePageSize } from '../../utils/constants';
// import { useDispatch, useSelector } from 'react-redux';
// import { DeleteFilled, WarningOutlined, PlusOutlined, DownOutlined, MessageOutlined, EyeOutlined } from "@ant-design/icons";
// import { useCurrentUserContext } from '../../context/currentUserContext';
// import FgasDocumentsServices from '../../services/fgasDocumentServices';
// import { Link as RouterLink } from "react-router-dom";
// import "./fgasDocuments.scss";
// import { PageHeader } from '../../components/common/pageHeader';
// import { downloadSelectedDocPdfFiles, handleDateConvertForApis } from '../../utils/functions';
// import dayjs from 'dayjs';
// import * as XLSX from 'xlsx-js-style';
// import * as FileSaver from "file-saver";
// import { group1Rights, group2Rights } from '../../configs/auth/roleRights';
// import { fetchSuppliersList } from '../../state/slices/suppliersListSlice';
// import UsersServices from '../../services/usersServices';
// import CreateDocumentFlux from '../documents/newDocumentFlux';
// import DocumentsServices from '../../services/documentsServices';

// const { RangePicker } = DatePicker;
// const { Text, Link } = Typography;

// const FgasDocumentsList = () => {

//   let filtersInitValues = {
//     code: "",
//     interventionTypeId: null,
//     workingStatusId: null,
//     anomaly: null,
//     supplierId: null,
//     operatore: "",
//     hasNotes: false,
//     flux: "",
//     hasAnomaly: false,
//     fileCommunicazioneName: "",

//     dateAddedFrom: null,
//     dateAddedTo: null,
//     dateAddedRange: null,

//     lastUpdatedDateFrom: null,
//     lastUpdatedDateTo: null,
//     dateUpdatedRange: null
//   };

//   const anomaliesList = useSelector(state => state.anomalies.anomalies);
//   const suppliersList = useSelector(state => state.suppliers.suppliers);
//   const docStatusList = useSelector(state => state.docStatus.docStatus);
//   const intervetionTypesList = useSelector(state => state.intervetionTypes.intervetionTypes);
//   const { roles } = useSelector((state) => state.roles);
//   const dispatch = useDispatch();
//   const { currentUser } = useCurrentUserContext();
//   const [documents, setDocuments] = useState([]);
//   const [loadingData, setLoadingData] = useState(false);
//   const [pageNumber, setPageNumber] = useState(1);
//   const [sorterColumn, setSorterColumn] = useState("");
//   const [operatorUsers, setOperatorUsers] = useState(null);
//   const [filterValues, setFilterValues] = useState(filtersInitValues);
//   const [totalCountRecords, setTotalCountRecords] = useState(null);
//   const [showDocumentFluxModal, setShowDocumentFluxModal] = useState(false);
//   const [loadingFlux, setLoadingFlux] = useState(false);

//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [hasAllSelection, setHasAllSelection] = useState(false);
//   const [loadingExcelDataExport, setLoadingExcelDataExport] = useState(false);

//   useEffect(() => {
//     if (!currentUser) return;
//     dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
//   }, [dispatch, currentUser]);

//   useEffect(() => {
//     getFgasDocuments(filterValues);
//   }, [
//     filterValues.anomaly,
//     filterValues.workingStatusId,
//     filterValues.interventionTypeId,
//     filterValues.supplierId,
//     filterValues.dateAddedRange,
//     filterValues.dateUpdatedRange,
//     filterValues.hasAnomaly,
//     filterValues.hasNotes,
//     pageNumber, sorterColumn
//   ]);

//   const columns = [
//     {
//       title: "Opzioni",
//       key: "actions",
//       width: "150px",
//       render: (_, record) => (
//         <Space size="middle">
//           <EyeOutlined style={{ color: "#023B72", marginRight: "5px" }} onClick={() => onDocumentPdfView(record.id)} />
//           <MessageOutlined style={{ color: record.notesViewed ? 'blue' : 'green' }} />
//           <RouterLink style={{ color: "#0f4d65" }} to={{ pathname: `${menuLinks.fgas}/view/id/${record.id}` }}>Apri</RouterLink>
//         </Space>
//       ),
//       onCell: () => ({
//         style: {
//           whiteSpace: "nowrap", // prevent wrapping
//         },
//       }),
//       width: 1, // let browser auto-size to content
//     },

//     {
//       title: "Codice Univoco",
//       dataIndex: "code",
//       key: "code",
//       sorter: (a, b) => {
//         a = a.code || "";
//         b = b.code || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Manutentore",
//       dataIndex: "supplierName",
//       key: "supplierName",
//       sorter: (a, b) => {
//         a = a.supplierName || "";
//         b = b.supplierName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Intervento",
//       dataIndex: "interventionTypeName",
//       key: "interventionTypeName",
//       sorter: (a, b) => {
//         a = a.interventionTypeName || "";
//         b = b.interventionTypeName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Operatore",
//       dataIndex: "operatore",
//       key: "operatore",
//       sorter: (a, b) => {
//         a = a.operatore || "";
//         b = b.operatore || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Stato",
//       dataIndex: "workingStatusName",
//       key: "workingStatusName",
//       sorter: (a, b) => {
//         a = a.workingStatusName || "";
//         b = b.workingStatusName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       onCell: () => ({
//         style: {
//           whiteSpace: "wrap", // prevent wrapping
//         },
//       }),
//       width: 1, // let browser auto-size to content
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Anomalia",
//       dataIndex: "anomalyName",
//       key: "anomalyName",
//       sorter: (a, b) => {
//         a = a.anomalyName || "";
//         b = b.anomalyName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Batch",
//       dataIndex: "flux",
//       key: "flux",
//       sorter: (a, b) => {
//         a = a.flux || "";
//         b = b.flux || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       render: (_, record) => {       
//           return (           
//               <Text style={{ width: 100 }}
//                 ellipsis={{ tooltip: record.flux }}>{record.flux}
//               </Text>
//           )        
//       }
//     },
//     {
//       title: "Data caricamento",
//       dataIndex: "dateAdded",
//       key: "dateAdded",
//       width: "140px",
//       sorter: (a, b) => {
//         a = a.dateAdded || "";
//         b = b.dateAdded || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       render: (text) => (text ? dayjs(text).format(dateFormat) : ""),
//       onCell: () => ({
//         style: {
//           whiteSpace: "nowrap", // prevent wrapping
//         },
//       }),
//       width: 1, // let browser auto-size to content
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       key: "action3",
//       width: "50px",
//       render: (_, record) => {
//         return (
//           <>
//             {group1Rights(currentUser) && (
//               <Popconfirm
//                 placement="topRight"
//                 key="remove"
//                 title="Vuoi eliminare questo documento?"
//                 icon={<WarningOutlined style={{ color: "#f7c924" }} />}
//                 okText="Si"
//                 cancelText="No"
//                 onConfirm={() => onRemoveDocument(record.id)}
//               >
//                 <DeleteFilled style={{ color: "#023B72" }} title={"Elimina Documento"} />
//               </Popconfirm>
//             )}
//           </>
//         );
//       },
//     },
//   ];


//   const getUsersList = async () => {
//     let role = roles.find(item => item.code === roleCode.operator);
//     const filterObj = {
//       roleID: role.value,
//       enabled: true
//     }
//     try {
//       const respData = await UsersServices.getUsers(filterObj);
//       if (respData.success) {
//         const res = respData.responseObject.value.usersList;
//         const objectsArray = res ? res.map((item) => ({ value: item.id, label: `${item.name} ${item.surname}` })) : [];
//         setOperatorUsers(objectsArray);
//       }
//       else {
//         message.error(notifyMessages.errorAccured);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//     }
//   };

//   const handelCreateFlux = async (values) => {
//     const formData = new FormData();
//     formData.append("zipFile", values.file.file);

//     if (values.operatorId) {
//       formData.append("operatorID", values.operatorId);
//     }
//     else {
//       formData.append("operatorID", currentUser.id);
//     }

//     setLoadingFlux(true);
//     try {
//       const respData = await DocumentsServices.addDocumentFlux(formData);

//       if (respData.success) {
//         message.success(notifyMessages.addSuccess);
//         setShowDocumentFluxModal(false);
//         getFgasDocuments(filterValues);
//       } else {
//         // Show backend error message
//         const errorMessage = respData?.errorDetail?.errorMessage || notifyMessages.errorAccured;
//         message.error(errorMessage);
//       }
//     } catch (error) {
//       message.error(notifyMessages.updateFailed);
//     } finally {
//       setLoadingFlux(false);
//     }
//   };

//   const generateColumn = () => {
//     let tableColums = columns;

//     const fileCommunicazioneColumn = {
//       title: "File Communicazione",
//       dataIndex: "fileCommunicazioneName",
//       key: "fileCommunicazioneName",
//       sorter: (a, b) => {
//         a = a.fileCommunicazioneName || "";
//         b = b.fileCommunicazioneName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       // className: 'doc-table-wrap-cell',
//       render: (_, record) => {
//         if (record.fileCommunicazionePath && record.fileCommunicazioneName) {
//           return (
//             <Link
//               href={record.fileCommunicazionePath}
//               download
//             >
//               <Text style={{ width: 100, color: "#1677ff" }}
//                 ellipsis={{ tooltip: record.fileCommunicazioneName }}>{record.fileCommunicazioneName}
//               </Text>
//             </Link>
//           )
//         }
//       },
//     };

//     tableColums.splice(7, 0, fileCommunicazioneColumn);

//     return tableColums;
//   }

//   const getFgasDocuments = async (filterValues) => {

//     let filterObj = filterValues;
//     filterObj["pageNumber"] = pageNumber;
//     filterObj["sortColumn"] = sorterColumn;
//     filterObj["userID"] = currentUser.id;

//     setLoadingData(true)
//     try {
//       const respData = await FgasDocumentsServices.getFgasDocuments(filterObj);

//       if (respData.success) {
//         let result = respData.responseObject.value.document_FGAS;
//         setDocuments(result);

//         if (result && result.length > 0)
//           setTotalCountRecords(result[0].totalCount);

//         if (hasAllSelection) {
//           setSelectedRowKeys(result.map(doc => doc.id));
//         }


//       }

//       setLoadingData(false);

//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//       setLoadingData(false);
//     }
//   };

//   const getSelectedDocuments = async () => {
//     const docIds = hasAllSelection ? null : selectedRowKeys.join(",");

//     const payload = {
//       sortColumn: sorterColumn && sorterColumn.trim() !== "" ? sorterColumn : "id",
//       docIdList: docIds,
//       userID: currentUser.id
//     };
//     setLoadingExcelDataExport(true);
//     try {
//       const respData = await FgasDocumentsServices.getSelectedDocumentsList(payload);
//       if (respData.success) {

//         let result = respData.responseObject.value.document_FGASExport_DTO;
//         if (result && result.length > 0) {
//           createExcelDataFile(result);
//         }
//         handleDeselectAll();
//         setLoadingExcelDataExport(false);
//       } else {
//         message.error(notifyMessages.errorAccured);
//         setLoadingExcelDataExport(false);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//       setLoadingExcelDataExport(false);
//     }
//   };

//   const getDocumentAttachmentsExportFiles = async () => {
//     // const docIds = selectedDocArray.map(doc => doc?.id).filter(id => id).join(",");
//     const docIds = hasAllSelection ? null : selectedRowKeys.join(",");

//     setLoadingExcelDataExport(true)
//     let filterObj = filterValues;
//     filterObj["docIdList"] = docIds;
//     filterObj['userID'] = currentUser.id;

//     try {
//       const respData = await FgasDocumentsServices.getDocumentListAttachments(filterObj);
//       if (respData.success) {
//         let result = respData.responseObject.value.docListPDFs;
//         if (result && result.length > 0) {
//           downloadSelectedDocPdfFiles(result, "Esportazione-Portale");
//         }
//         else {
//           message.info(notifyMessages.noFileFound);
//         }
//         handleDeselectAll();
//       }
//       setLoadingExcelDataExport(false);
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//       setLoadingExcelDataExport(false);
//     }
//   };

//   const createExcelDataFile = (data) => {
//     if (!data || data.length === 0) {
//       message.info("Nessun dato trovato");
//       return;
//     }
//     let formattedDocData = data.map((item) => ({
//       Code: item.code,
//       WorkingStatusName: item.workingStatusName,
//       AnomalyName: item.anomalyName ? item.anomalyName : "Nessun Anomalia",
//       DateAdded: item.dateAdded ? dayjs(item.dateAdded).format(dateFormat) : "",
//       InterventionTypeName: item.interventionTypeName,
//       Operatore: item.operatore,
//       PivA_Operatore: item.pivA_Operatore,
//       supplierName: item.supplierName,
//       flux: item.flux
//     }));

//     const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
//     const fileExtension = ".xlsx";
//     const fileName = `ESPORTAZIONE-PORTALE-${dayjs().format(dateFormat)}`;
//     // Define headers
//     const headers = [["Codice", "Stato", "Anomalia", "Data Caricamento", "Intervento", "Operatore", "PIVA / CF Operatore", "Manutentore", "Flux"],
//     ];
//     const ws = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_json(ws, formattedDocData, { origin: "A2", skipHeader: true });
//     XLSX.utils.sheet_add_aoa(ws, headers);
//     const wb = { Sheets: { "Esportazione Fatture": ws }, SheetNames: ["Esportazione Fatture"] };
//     // Set column width
//     ws["!cols"] = Array(25).fill({ wpx: 120 });
//     // Apply bold style to headers
//     for (let key in ws) {
//       if (typeof ws[key] !== "object") continue;
//       let cell = XLSX.utils.decode_cell(key);
//       if (cell.r === 1) {
//         let p = key.replace("2", "1");
//         ws[p].s = { font: { bold: true } };
//       }
//     }
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const dataBlob = new Blob([excelBuffer], { type: fileType });
//     FileSaver.saveAs(dataBlob, fileName + fileExtension);
//   };

//   const onRemoveDocument = async (documentId) => {
//     try {
//       const respData = await FgasDocumentsServices.deleteDocument(documentId);
//       if (respData.success) {
//         message.success(notifyMessages.operationSuccess);
//         getFgasDocuments(filterValues);
//       } else {
//         message.error(notifyMessages.errorAccured);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//     }
//   };

//   const onPageOrOrderChange = (pagination, filters, sorter) => {
//     setPageNumber(pagination.current);
//     if (sorter && sorter.field) {
//       let sorterQuote = "";
//       if (sorter.order === "descend") {
//         sorterQuote = "[" + sorter.field + "]" + " " + "DESC";
//       }
//       if (sorter.order === "ascend") {
//         sorterQuote = "[" + sorter.field + "]" + " " + "ASC";
//       }
//       setSorterColumn(sorterQuote);
//     } else {
//       setSorterColumn("");
//     }
//   };

//   const onFilter = () => {
//     getFgasDocuments(filterValues);
//     setPageNumber(1);
//   };

//   const clearFilters = () => {
//     setPageNumber(1);
//     setFilterValues(filtersInitValues);
//     getFgasDocuments(filtersInitValues);
//   };

//   const handelFilterChange = (name, value) => {
//     if (name === "dateAdded") {
//       let startDateAdded = handleDateConvertForApis(value[0].$d);
//       let endDateAdded = handleDateConvertForApis(value[1].$d);
//       setFilterValues((prev) => ({ ...prev, dateAddedFrom: startDateAdded }));
//       setFilterValues((prev) => ({ ...prev, dateAddedTo: endDateAdded }));
//       setFilterValues((prev) => ({ ...prev, dateAddedRange: value }));
//     }
//     else if (name === "dateUpdated") {
//       let startDateUpdated = handleDateConvertForApis(value[0].$d);
//       let endDateUpdated = handleDateConvertForApis(value[1].$d);
//       setFilterValues((prev) => ({ ...prev, lastUpdatedDateFrom: startDateUpdated }));
//       setFilterValues((prev) => ({ ...prev, lastUpdatedDateTo: endDateUpdated }));
//       setFilterValues((prev) => ({ ...prev, dateUpdatedRange: value }));
//     }
//     else {
//       setFilterValues((prev) => ({ ...prev, [name]: value }));
//     }
//   }

//   const onDocumentPdfView = async (documentId) => {
//     message.warning(notifyMessages.generateDocumentPdfLoading);
//     try {
//       const respData = await FgasDocumentsServices.readDocumentPDF(documentId);
//       if (respData.success) {
//         let pdfData = respData.responseObject.value;
//         if (pdfData.documentPdfURI) {
//           // handle and convert base64 to PDF
//           let base64str = pdfData.pdfArray;
//           let binary = atob(base64str.replace(/\s/g, ""));
//           let len = binary.length;
//           let buffer = new ArrayBuffer(len);
//           let view = new Uint8Array(buffer);
//           for (let i = 0; i < len; i++) {
//             view[i] = binary.charCodeAt(i);
//           }
//           // create the blob object with content-type "application/pdf"
//           let blob = new Blob([view], { type: "application/pdf" });
//           let url = URL.createObjectURL(blob);
//           window.open(url, "Document", "width=800,height=600");
//         } else {
//           message.error(notifyMessages.noFileFound);
//         }
//       } else {
//         message.error(notifyMessages.errorAccured);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//     }
//   };

//   const totalPages = Math.ceil(totalCountRecords / tablePageSize);

//   const panelItems = [
//     {
//       key: '1',
//       label: `Filtra documenti - Visualizzando ${totalCountRecords ? totalCountRecords : ""} documenti (Pagina: ${pageNumber}/${totalPages})`,
//       children: (
//         <>
//           <Row gutter={{ lg: 24 }}>

//             <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Codice Univoco</span>
//                 <Input value={filterValues.code} placeholder='Codice' onChange={(e) => handelFilterChange("code", e.target.value)} />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Manutentore</span>
//                 <Select
//                   value={filterValues.supplierId}
//                   style={{ width: "100%" }}
//                   showSearch
//                   optionFilterProp="label"
//                   placeholder="Manutentore"
//                   options={suppliersList}
//                   onSelect={(value) => handelFilterChange("supplierId", value)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Intervento</span>
//                 <Select
//                   value={filterValues.interventionTypeId}
//                   style={{ width: "100%" }}
//                   showSearch
//                   optionFilterProp="label"
//                   placeholder="Intervento"
//                   options={intervetionTypesList}
//                   onSelect={(value) => handelFilterChange("interventionTypeId", value)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Stato</span>
//                 <Select
//                   value={filterValues.workingStatusId}
//                   style={{ width: "100%" }}
//                   showSearch
//                   optionFilterProp="label"
//                   placeholder="Stato"
//                   options={docStatusList}
//                   onSelect={(value) => handelFilterChange("workingStatusId", value)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Anomalia</span>
//                 <Select
//                   value={filterValues.anomaly}
//                   style={{ width: "100%" }}
//                   showSearch
//                   optionFilterProp="label"
//                   placeholder="Anomalia"
//                   options={anomaliesList}
//                   onSelect={(value) => handelFilterChange("anomaly", value)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Operatore</span>
//                 <Input value={filterValues.code} placeholder='Operatore' onChange={(e) => handelFilterChange("operatore", e.target.value)} />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Data caricamento</span>
//                 <RangePicker
//                   value={filterValues.dateAddedRange}
//                   style={{ width: "100%" }}
//                   format={dateFormat}
//                   placeholder={["Data inizio", 'Data fine']}
//                   onChange={(dates) => handelFilterChange("dateAdded", dates)}
//                   allowClear={false}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Data modifica</span>
//                 <RangePicker
//                   value={filterValues.dateUpdatedRange}
//                   style={{ width: "100%" }}
//                   format={dateFormat}
//                   placeholder={["Data inizio", 'Data fine']}
//                   onChange={(dates) => handelFilterChange("dateUpdated", dates)}
//                   allowClear={false}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Batch</span>
//                 <Input value={filterValues.flux} placeholder='Batch' onChange={(e) => handelFilterChange("flux", e.target.value)} />
//               </Space>
//             </Col>

//             <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>File Communicazione</span>
//                 <Input value={filterValues.fileCommunicazioneName} placeholder='File Communicazione' onChange={(e) => handelFilterChange("fileCommunicazioneName", e.target.value)} />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Note Presenti</span>
//                 <Switch checked={filterValues.hasNotes} onChange={(checked) => handelFilterChange("hasNotes", checked)} />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Anomalie Presenti</span>
//                 <Switch checked={filterValues.hasAnomaly} onChange={(checked) => handelFilterChange("hasAnomaly", checked)} />
//               </Space>
//             </Col>

//           </Row>
//           <Divider />
//           <Row gutter={{ lg: 24 }}>
//             <Col className="gutter-row fliterButtons" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>

//               <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
//               <Button onClick={() => clearFilters()}> Rimuovi  </Button>
//             </Col>
//           </Row>
//         </>
//       )
//     }
//   ];

//   const exportSelectedDocuments = () => {
//     getSelectedDocuments();
//   };

//   const toggleCreateFluxModal = () => {
//     setShowDocumentFluxModal(true);
//     getUsersList();
//   };

//   const onSelectChange = (newSelectedRowKeys, selectedRows) => {
//     setSelectedRowKeys(newSelectedRowKeys);
//   };

//   const handleSelectPage = () => {
//     setHasAllSelection(false);
//     const selectedPageDocIds = documents.map(doc => doc.id);
//     setSelectedRowKeys(selectedPageDocIds);
//   };

//   const handleSelectAll = () => {
//     setHasAllSelection(true);
//     const allDocumentIds = documents.map(doc => doc.id);
//     setSelectedRowKeys(allDocumentIds);
//   };

//   const handleDeselectAll = () => {
//     setSelectedRowKeys([]);
//     setHasAllSelection(false);
//   };

//   const rowSelection = {
//     selectedRowKeys,
//     preserveSelectedRowKeys: true,
//     onChange: onSelectChange,
//     columnWidth: "50px",
//   };

//   const hasSelected = selectedRowKeys.length > 0;
//   const selectedRowsCount = selectedRowKeys.length;

//   const items = (
//     [
//       {
//         key: '1',
//         label: (
//           <Text onClick={handleSelectPage}>Seleziona pagina</Text>
//         )
//       },
//       {
//         key: '2',
//         label: <Text onClick={handleSelectAll}>Seleziona tutto</Text>
//       }
//     ])

//   return (
//     <>
//       {showDocumentFluxModal &&
//         <CreateDocumentFlux
//           showDocumentFluxModal={showDocumentFluxModal}
//           handelModalClose={() => setShowDocumentFluxModal(false)}
//           handelCreateFlux={handelCreateFlux}
//           loadingButton={loadingFlux}
//           operators={operatorUsers}
//         />
//       }

//       <PageHeader title="FGAS" />

//       <Row justify="center" align="top" gutter={[16, 16]} className='fgasDocuments'>

//         <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//           <Collapse
//             size='small'
//             defaultActiveKey={['1']}
//             items={panelItems}
//           />

//         </Col>

//         <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//           <Card className="docListButtons">
//             <Row justify="space-between" align="middle">
//               <Col>
//                 <Space size="middle">
//                   <Dropdown menu={{ items }}>
//                     <Button type="default">Seleziona {`(${selectedRowsCount})`}<DownOutlined /></Button>
//                   </Dropdown>
//                   <Button type="default" onClick={handleDeselectAll}>Deseleziona tutto</Button>
//                 </Space>
//               </Col>

//               {group2Rights(currentUser) && (
//                 <Col>
//                   <Space size="middle">
//                     <Button type="primary" onClick={() => toggleCreateFluxModal()} icon={<PlusOutlined />}>Carica flusso</Button>
//                     <Button type="primary" icon={<PlusOutlined />}><RouterLink to={menuLinks.fgas + "/new"}>Carica documento</RouterLink></Button>
//                   </Space>
//                 </Col>
//               )}
//             </Row>
//           </Card>

//         </Col>


//         <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//           {/* <Card style={{ width: '100%' }} className="docListTable"> */}
//           <Card style={{ display: "inline-block", width: "100%" }} className="docListTable">
//             <Table
//               className='customTableRows'
//               bordered
//               rowClassName={(_, index) =>
//                 index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
//               }
//               loading={loadingData}
//               dataSource={documents}
//               columns={generateColumn()}
//               rowKey={obj => obj.id}
//               rowSelection={rowSelection}
//               onChange={(pagination, filters, sorter) =>
//                 onPageOrOrderChange(pagination, filters, sorter)
//               }
//               pagination={{
//                 pageSize: tablePageSize,
//                 showSizeChanger: false,
//                 total: totalCountRecords || 0,
//                 current: pageNumber
//               }}
//               // tableLayout="fixed"
//               style={{ width: "auto" }}
//             />
//             <Row gutter={{ lg: 24 }}>
//               <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//                 <div className="doc-bottom-button-wrapper">
//                   <Button type="primary" loading={loadingExcelDataExport} disabled={!hasSelected} onClick={getDocumentAttachmentsExportFiles} className='mr10'> Scarica {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
//                   <Button type="primary" loading={loadingExcelDataExport} onClick={exportSelectedDocuments} disabled={!hasSelected} className='mr10'> Esporta {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
//                 </div>
//               </Col>
//             </Row>
//           </Card>
//         </Col>
//       </Row>

//     </>

//   );
// }
// export default FgasDocumentsList;


import { useEffect, useState } from 'react';
import { Col, Collapse, Input, message, Popconfirm, Row, Select, Space, Table, Divider, Button, Card, DatePicker, Switch, Dropdown, Typography } from 'antd';
import { dateFormat, menuLinks, notifyMessages, roleCode, tablePageSize } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteFilled, WarningOutlined, PlusOutlined, DownOutlined, MessageOutlined, EyeOutlined } from "@ant-design/icons";
import { useCurrentUserContext } from '../../context/currentUserContext';
import FgasDocumentsServices from '../../services/fgasDocumentServices';
import { Link as RouterLink } from "react-router-dom";
import "./fgasDocuments.scss";
import { PageHeader } from '../../components/common/pageHeader';
import { downloadSelectedDocPdfFiles, handleDateConvertForApis } from '../../utils/functions';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from "file-saver";
import { group1Rights, group2Rights } from '../../configs/auth/roleRights';
import { fetchSuppliersList } from '../../state/slices/suppliersListSlice';
import UsersServices from '../../services/usersServices';
import CreateDocumentFlux from '../documents/newDocumentFlux';
import DocumentsServices from '../../services/documentsServices';
import Filters from './filters';

const { RangePicker } = DatePicker;
const { Text, Link } = Typography;

const FgasDocumentsList = () => {
  const FILTER_STORAGE_KEY = 'fgasDocumentsListFilters';
  const PAGE_STORAGE_KEY = 'fgasDocumentsListPage';
  const SORTER_STORAGE_KEY = 'fgasDocumentsListSorter';

  let filtersInitValues = {
    code: "",
    interventionTypeId: null,
    workingStatusId: null,
    anomaly: null,
    supplierId: null,
    operatore: "",
    hasNotes: false,
    flux: "",
    hasAnomaly: false,
    fileCommunicazioneName: "",

    dateAddedFrom: null,
    dateAddedTo: null,
    dateAddedRange: null,

    lastUpdatedDateFrom: null,
    lastUpdatedDateTo: null,
    dateUpdatedRange: null
  };

  // Function to load filters from localStorage
  const loadFiltersFromStorage = () => {
    try {
      const savedFilters = localStorage.getItem(FILTER_STORAGE_KEY);
      if (savedFilters) {
        const parsedFilters = JSON.parse(savedFilters);
        // Validate that all expected filter keys exist
        const validatedFilters = { ...filtersInitValues };
        Object.keys(filtersInitValues).forEach(key => {
          if (parsedFilters.hasOwnProperty(key)) {
            // Handle date ranges properly
            if (key === 'dateAddedRange' || key === 'dateUpdatedRange') {
              if (parsedFilters[key] && Array.isArray(parsedFilters[key])) {
                validatedFilters[key] = parsedFilters[key].map(date => dayjs(date));
              }
            } else {
              validatedFilters[key] = parsedFilters[key];
            }
          }
        });
        return validatedFilters;
      }
    } catch (error) {
      console.error('Error loading filters from localStorage:', error);
    }
    return filtersInitValues;
  };

  // Function to save filters to localStorage
  const saveFiltersToStorage = (filters) => {
    try {
      // Convert dayjs objects to string format for storage
      const filtersToSave = { ...filters };
      if (filtersToSave.dateAddedRange && Array.isArray(filtersToSave.dateAddedRange)) {
        filtersToSave.dateAddedRange = filtersToSave.dateAddedRange.map(date => 
          date ? date.format() : null
        );
      }
      if (filtersToSave.dateUpdatedRange && Array.isArray(filtersToSave.dateUpdatedRange)) {
        filtersToSave.dateUpdatedRange = filtersToSave.dateUpdatedRange.map(date => 
          date ? date.format() : null
        );
      }
      localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filtersToSave));
    } catch (error) {
      console.error('Error saving filters to localStorage:', error);
    }
  };

  // Function to load page number from localStorage
  const loadPageFromStorage = () => {
    try {
      const savedPage = localStorage.getItem(PAGE_STORAGE_KEY);
      if (savedPage) {
        const parsedPage = parseInt(savedPage, 10);
        return isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;
      }
    } catch (error) {
      console.error('Error loading page from localStorage:', error);
    }
    return 1;
  };

  // Function to save page number to localStorage
  const savePageToStorage = (page) => {
    try {
      localStorage.setItem(PAGE_STORAGE_KEY, page.toString());
    } catch (error) {
      console.error('Error saving page to localStorage:', error);
    }
  };

  // Function to load sorter from localStorage
  const loadSorterFromStorage = () => {
    try {
      const savedSorter = localStorage.getItem(SORTER_STORAGE_KEY);
      if (savedSorter) {
        return savedSorter;
      }
    } catch (error) {
      console.error('Error loading sorter from localStorage:', error);
    }
    return "";
  };

  // Function to save sorter to localStorage
  const saveSorterToStorage = (sorter) => {
    try {
      localStorage.setItem(SORTER_STORAGE_KEY, sorter);
    } catch (error) {
      console.error('Error saving sorter to localStorage:', error);
    }
  };

  // Function to clear all stored data
  const clearStorageData = () => {
    try {
      localStorage.removeItem(FILTER_STORAGE_KEY);
      localStorage.removeItem(PAGE_STORAGE_KEY);
      localStorage.removeItem(SORTER_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing storage data:', error);
    }
  };

  const suppliersList = useSelector(state => state.suppliers.suppliers);
  const docStatusList = useSelector(state => state.docStatus.docStatus);
  const intervetionTypesList = useSelector(state => state.intervetionTypes.intervetionTypes);
  const { roles } = useSelector((state) => state.roles);
  const dispatch = useDispatch();
  const { currentUser } = useCurrentUserContext();
  const [documents, setDocuments] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  // Initialize state with data from localStorage
  const [pageNumber, setPageNumber] = useState(() => loadPageFromStorage());
  const [sorterColumn, setSorterColumn] = useState(() => loadSorterFromStorage());
  const [filterValues, setFilterValues] = useState(() => loadFiltersFromStorage());

  const [operatorUsers, setOperatorUsers] = useState(null);
  const [totalCountRecords, setTotalCountRecords] = useState(null);
  const [showDocumentFluxModal, setShowDocumentFluxModal] = useState(false);
  const [loadingFlux, setLoadingFlux] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [hasAllSelection, setHasAllSelection] = useState(false);
  const [loadingExcelDataExport, setLoadingExcelDataExport] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
  }, [dispatch, currentUser]);

  // useEffect(() => {
  //   getFgasDocuments(filterValues);
  // }, [
  //   filterValues.workingStatusId,
  //   filterValues.interventionTypeId,
  //   filterValues.supplierId,
  //   filterValues.dateAddedRange,
  //   filterValues.dateUpdatedRange,
  //   filterValues.hasAnomaly,
  //   filterValues.hasNotes,
  //   pageNumber, sorterColumn
  // ]);

    useEffect(() => {
    getFgasDocuments();
  }, [pageNumber, sorterColumn, filterValues]);

  // Save to localStorage whenever filterValues change
  useEffect(() => {
    saveFiltersToStorage(filterValues);
  }, [filterValues]);

  // Save to localStorage whenever pageNumber changes
  useEffect(() => {
    savePageToStorage(pageNumber);
  }, [pageNumber]);

  // Save to localStorage whenever sorterColumn changes
  useEffect(() => {
    saveSorterToStorage(sorterColumn);
  }, [sorterColumn]);

  const viewCommunicationFile = async (fileUrl) => {
    message.warning(notifyMessages.generateDocumentPdfLoading)

    if (fileUrl) {
      fetch(fileUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          // Add any auth headers if needed
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.blob();
        })
        .then(blob => {
          // Ensure it's treated as PDF
          const pdfBlob = new Blob([blob], { type: 'application/pdf' });
          const url = URL.createObjectURL(pdfBlob);
          window.open(url, "Document", "width=800,height=600");
        })
        .catch(error => {
          console.error('Error opening PDF:', error);
          message.error(notifyMessages.noFileFound);
        });
    } else {
      message.error(notifyMessages.noFileFound);
    }

  };

  const columns = [
    {
      title: "Opzioni",
      key: "actions",
      // width: "150px",
      render: (_, record) => (
        <Space size="middle">
          <EyeOutlined style={{ color: "#023B72", marginRight: "5px" }} onClick={() => onDocumentPdfView(record.id)} />
          <MessageOutlined style={{ color: record.notesViewed ? 'green' : 'red' }} />
          <RouterLink style={{ color: "#0f4d65" }} to={{ pathname: `${menuLinks.fgas}/view/id/${record.id}` }}>Apri</RouterLink>
        </Space>
      ),
      // onCell: () => ({
      //   style: {
      //     whiteSpace: "nowrap",
      //   },
      // }),
      // width: 1
    },

    {
      title: "Codice Univoco",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => {
        a = a.code || "";
        b = b.code || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      // className: 'doc-table-wrap-cell',
      // width: "80px"
    },
    {
      title: "Manutentore",
      dataIndex: "supplierName",
      key: "supplierName",
      sorter: (a, b) => {
        a = a.supplierName || "";
        b = b.supplierName || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      // className: 'doc-table-wrap-cell',
      // width: "90px",
    },
    {
      title: "Intervento",
      dataIndex: "interventionTypeName",
      key: "interventionTypeName",
      sorter: (a, b) => {
        a = a.interventionTypeName || "";
        b = b.interventionTypeName || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      // className: 'doc-table-wrap-cell'
    },
    {
      title: "Operatore",
      dataIndex: "operatore",
      key: "operatore",
      sorter: (a, b) => {
        a = a.operatore || "";
        b = b.operatore || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      // className: 'doc-table-wrap-cell'
    },
    {
      title: "Stato",
      dataIndex: "workingStatusName",
      key: "workingStatusName",
      sorter: (a, b) => {
        a = a.workingStatusName || "";
        b = b.workingStatusName || "";
        return a.localeCompare(b);
      },
      // className: 'doc-table-wrap-cell',
      // width: "80px",
      showSorterTooltip: false,
    },
    {
      title: "Anomalia",
      dataIndex: "anomalyName",
      key: "anomalyName",
      sorter: (a, b) => {
        a = a.anomalyName || "";
        b = b.anomalyName || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      // className: 'doc-table-wrap-cell'
    },
     {
      title: "Batch",
      dataIndex: "flux",
      key: "flux",
      sorter: (a, b) => {
        a = a.flux || "";
        b = b.flux || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      className: 'doc-table-wrap-cell',
      //  width:"120px",
      onCell: () => ({
        style: {
          fontSize: "12px"
        },
      }),
    },
    // {
    //   title: "Batch",
    //   dataIndex: "flux",
    //   key: "flux",
    //   sorter: (a, b) => {
    //     a = a.flux || "";
    //     b = b.flux || "";
    //     return a.localeCompare(b);
    //   },
    //   showSorterTooltip: false,
    //   render: (_, record) => {       
    //       return (           
    //           <Text style={{ width: 100 }}
    //             ellipsis={{ tooltip: record.flux }}>{record.flux}
    //           </Text>
    //       )        
    //   }
    // },
    {
      title: "Data caricamento",
      dataIndex: "dateAdded",
      key: "dateAdded",     
      sorter: (a, b) => {
        a = a.dateAdded || "";
        b = b.dateAdded || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      render: (text) => (text ? dayjs(text).format(dateFormat) : ""),
      // onCell: () => ({
      //   style: {
      //     whiteSpace: "nowrap", 
      //   },
      // }),
    },
    {
      key: "action3",
      width: "20px",
      render: (_, record) => {
        return (
          <>
            {group1Rights(currentUser) && (
              <Popconfirm
                placement="topRight"
                key="remove"
                title="Vuoi eliminare questo documento?"
                icon={<WarningOutlined style={{ color: "#f7c924" }} />}
                okText="Si"
                cancelText="No"
                onConfirm={() => onRemoveDocument(record.id)}
              >
                <DeleteFilled style={{ color: "#023B72" }} title={"Elimina Documento"} />
              </Popconfirm>
            )}
          </>
        );
      },
    },
  ];

  const getUsersList = async () => {
    let role = roles.find(item => item.code === roleCode.operator);
    const filterObj = {
      roleID: role.value,
      enabled: true
    }
    try {
      const respData = await UsersServices.getUsers(filterObj);
      if (respData.success) {
        const res = respData.responseObject.value.usersList;
        const objectsArray = res ? res.map((item) => ({ value: item.id, label: `${item.name} ${item.surname}` })) : [];
        setOperatorUsers(objectsArray);
      }
      else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const handelCreateFlux = async (values) => {
    const formData = new FormData();
    formData.append("zipFile", values.file.file);

    if (values.operatorId) {
      formData.append("operatorID", values.operatorId);
    }
    else {
      formData.append("operatorID", currentUser.id);
    }

    setLoadingFlux(true);
    try {
      const respData = await DocumentsServices.addDocumentFlux(formData);

      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setShowDocumentFluxModal(false);
        getFgasDocuments();
      } else {
        // Show backend error message
        const errorMessage = respData?.errorDetail?.errorMessage || notifyMessages.errorAccured;
        message.error(errorMessage);
      }
    } catch (error) {
      message.error(notifyMessages.updateFailed);
    } finally {
      setLoadingFlux(false);
    }
  };

  const generateColumn = () => {
    let tableColums = columns;

    const fileCommunicazioneColumn = {
      title: "File Comunicazione",
      dataIndex: "fileCommunicazioneName",
      key: "fileCommunicazioneName",
      sorter: (a, b) => {
        a = a.fileCommunicazioneName || "";
        b = b.fileCommunicazioneName || "";
        return a.localeCompare(b);
      },     
      showSorterTooltip: false,
      className: 'doc-table-wrap-cell',
      // width: "120px",
      
      render: (_, record) => {
        if (record.fileCommunicazionePath && record.fileCommunicazioneName) {
          return (
            <Link
              // href={record.fileCommunicazionePath}
              // download
              onClick={() => viewCommunicationFile(record.fileCommunicazionePath)}
            >
              <Text  style={{ width: 100, color: "#1677ff" }}
               >{record.fileCommunicazioneName}
              </Text>
            </Link>
          )
        }
      },
    };

    tableColums.splice(7, 0, fileCommunicazioneColumn);

    return tableColums;
  }

  const getFgasDocuments = async () => {

    let filterObj = filterValues;
    filterObj["pageNumber"] = pageNumber;
    filterObj["sortColumn"] = sorterColumn;
    filterObj["userID"] = currentUser.id;

    setLoadingData(true)
    try {
      const respData = await FgasDocumentsServices.getFgasDocuments(filterObj);

      if (respData.success) {
        let result = respData.responseObject.value.document_FGAS;
        setDocuments(result);

        if (result && result.length > 0) {
          setTotalCountRecords(result[0].totalCount);
        }
        else {
          setTotalCountRecords(0);
        }

        if (hasAllSelection) {
          setSelectedRowKeys(result.map(doc => doc.id));
        }

      }

      setLoadingData(false);

    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingData(false);
    }
  };

  const getSelectedDocuments = async () => {
    const docIds = hasAllSelection ? null : selectedRowKeys.join(",");

    // const payload = {
    //   sortColumn: sorterColumn && sorterColumn.trim() !== "" ? sorterColumn : "id",
    //   docIdList: docIds,
    //   userID: currentUser.id
    // };

      const filterObj = {
      ...filterValues,
      sortColumn: sorterColumn,
      userID: currentUser.id,
      docIdList: docIds
    };


    setLoadingExcelDataExport(true);
    try {
      const respData = await FgasDocumentsServices.getSelectedDocumentsList(filterObj);
      if (respData.success) {

        let result = respData.responseObject.value.document_FGASExport_DTO;
        if (result && result.length > 0) {
          createExcelDataFile(result);
        }
        handleDeselectAll();
        setLoadingExcelDataExport(false);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingExcelDataExport(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingExcelDataExport(false);
    }
  };

  const getDocumentAttachmentsExportFiles = async () => {
    // const docIds = selectedDocArray.map(doc => doc?.id).filter(id => id).join(",");
    const docIds = hasAllSelection ? null : selectedRowKeys.join(",");

    // setLoadingExcelDataExport(true)
    // let filterObj = filterValues;
    // filterObj["docIdList"] = docIds;
    // filterObj['userID'] = currentUser.id;

    const filterObj = {
      ...filterValues,
      sortColumn: sorterColumn,
      userID: currentUser.id,
      docIdList: docIds
    };

    setLoadingExcelDataExport(true)
    try {
      const respData = await FgasDocumentsServices.getDocumentListAttachments(filterObj);
      if (respData.success) {
        let result = respData.responseObject.value.docListPDFs;
        if (result && result.length > 0) {
           setLoadingExcelDataExport(true)
          await downloadSelectedDocPdfFiles(result, "Esportazione-Portale");
           setLoadingExcelDataExport(false)
        }
        else {
          message.info(notifyMessages.noFileFound);
        }
        handleDeselectAll();
      }
      setLoadingExcelDataExport(false);
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingExcelDataExport(false);
    }
  };

  const createExcelDataFile = (data) => {
    if (!data || data.length === 0) {
      message.info("Nessun dato trovato");
      return;
    }
    let formattedDocData = data.map((item) => ({
      Code: item.code,
      WorkingStatusName: item.workingStatusName,
      AnomalyName: item.anomalyName ? item.anomalyName : "Nessun Anomalia",
      DateAdded: item.dateAdded ? dayjs(item.dateAdded).format(dateFormat) : "",
      InterventionTypeName: item.interventionTypeName,
      Operatore: item.operatore,
      PivA_Operatore: item.pivA_Operatore,
      supplierName: item.supplierName,
      flux: item.flux
    }));

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = `ESPORTAZIONE-PORTALE-${dayjs().format(dateFormat)}`;
    // Define headers
    const headers = [["Codice", "Stato", "Anomalia", "Data Caricamento", "Intervento", "Operatore", "PIVA / CF Operatore", "Manutentore", "Flux"],
    ];
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_json(ws, formattedDocData, { origin: "A2", skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, headers);
    const wb = { Sheets: { "Esportazione Fatture": ws }, SheetNames: ["Esportazione Fatture"] };
    // Set column width
    ws["!cols"] = Array(25).fill({ wpx: 120 });
    // Apply bold style to headers
    for (let key in ws) {
      if (typeof ws[key] !== "object") continue;
      let cell = XLSX.utils.decode_cell(key);
      if (cell.r === 1) {
        let p = key.replace("2", "1");
        ws[p].s = { font: { bold: true } };
      }
    }
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataBlob, fileName + fileExtension);
  };

  const onRemoveDocument = async (documentId) => {
    try {
      const respData = await FgasDocumentsServices.deleteDocument(documentId);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        getFgasDocuments();
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const onPageOrOrderChange = (pagination, filters, sorter) => {
    setPageNumber(pagination.current);
    if (sorter && sorter.field) {
      let sorterQuote = "";
      if (sorter.order === "descend") {
        sorterQuote = "[" + sorter.field + "]" + " " + "DESC";
      }
      if (sorter.order === "ascend") {
        sorterQuote = "[" + sorter.field + "]" + " " + "ASC";
      }
      setSorterColumn(sorterQuote);
    } else {
      setSorterColumn("");
    }
  };

  const onFilter = () => {
    getFgasDocuments();
    setPageNumber(1);
  };

  const clearFilters = () => {
    // setPageNumber(1);
    // setFilterValues(filtersInitValues);
    // getFgasDocuments(filtersInitValues);
    // clearStorageData();

    setPageNumber(1);
    setFilterValues(filtersInitValues);
    // Clear localStorage when filters are cleared
    clearStorageData();
  };

  const handelFilterChange = (name, value) => {
    if (name === "dateAdded") {
      let startDateAdded = handleDateConvertForApis(value[0].$d);
      let endDateAdded = handleDateConvertForApis(value[1].$d);
      setFilterValues((prev) => ({ ...prev, dateAddedFrom: startDateAdded }));
      setFilterValues((prev) => ({ ...prev, dateAddedTo: endDateAdded }));
      setFilterValues((prev) => ({ ...prev, dateAddedRange: value }));
    }
    else if (name === "dateUpdated") {
      let startDateUpdated = handleDateConvertForApis(value[0].$d);
      let endDateUpdated = handleDateConvertForApis(value[1].$d);
      setFilterValues((prev) => ({ ...prev, lastUpdatedDateFrom: startDateUpdated }));
      setFilterValues((prev) => ({ ...prev, lastUpdatedDateTo: endDateUpdated }));
      setFilterValues((prev) => ({ ...prev, dateUpdatedRange: value }));
    }
    else {
      setFilterValues((prev) => ({ ...prev, [name]: value }));
    }
  }

  const onDocumentPdfView = async (documentId) => {
    message.warning(notifyMessages.generateDocumentPdfLoading);
    try {
      const respData = await FgasDocumentsServices.readDocumentPDF(documentId);
      if (respData.success) {
        let pdfData = respData.responseObject.value;
        if (pdfData.documentPdfURI) {
          // handle and convert base64 to PDF
          let base64str = pdfData.pdfArray;
          let binary = atob(base64str.replace(/\s/g, ""));
          let len = binary.length;
          let buffer = new ArrayBuffer(len);
          let view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }
          // create the blob object with content-type "application/pdf"
          let blob = new Blob([view], { type: "application/pdf" });
          let url = URL.createObjectURL(blob);
          window.open(url, "Document", "width=800,height=600");
        } else {
          message.error(notifyMessages.noFileFound);
        }
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };


  const totalPages = Math.ceil(totalCountRecords / tablePageSize);

  const panelItems = [
    {
      key: '1',
      label: `Filtra documenti - Visualizzando ${totalCountRecords ? totalCountRecords : ""} documenti (Pagina: ${pageNumber}/${totalPages})`,
      children: (
        <>
          <Row gutter={{ lg: 24 }}>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Codice Univoco</span>
                <Input value={filterValues.code} placeholder='Codice' onChange={(e) => handelFilterChange("code", e.target.value)} />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Manutentore</span>
                <Select
                  value={filterValues.supplierId}
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  placeholder="Manutentore"
                  options={suppliersList}
                  allowClear
                  onSelect={(value) => handelFilterChange("supplierId", value)}
                  onClear={()=>handelFilterChange("supplierId", null)}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Intervento</span>
                <Select
                  value={filterValues.interventionTypeId}
                  style={{ width: "100%" }}
                  showSearch
                  allowClear
                  optionFilterProp="label"
                  placeholder="Intervento"
                  options={intervetionTypesList}
                  onSelect={(value) => handelFilterChange("interventionTypeId", value)}
                  onClear={()=>handelFilterChange("interventionTypeId", null)}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Stato</span>
                <Select
                  value={filterValues.workingStatusId}
                  style={{ width: "100%" }}
                  showSearch
                  allowClear
                  optionFilterProp="label"
                  placeholder="Stato"
                  options={docStatusList}
                  onSelect={(value) => handelFilterChange("workingStatusId", value)}
                  onClear={()=>handelFilterChange("workingStatusId", null)}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Anomalia</span>
                 <Input value={filterValues.anomaly} placeholder='Anomalia' onChange={(e) => handelFilterChange("anomaly", e.target.value)} />
                {/* <Select
                  value={filterValues.anomaly}
                  style={{ width: "100%" }}
                  showSearch
                  allowClear
                  optionFilterProp="label"
                  placeholder="Anomalia"
                  options={anomaliesList}
                  onSelect={(value) => handelFilterChange("anomaly", value)}
                  onClear={()=>handelFilterChange("anomaly", null)}
                /> */}
              </Space>
            </Col>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Operatore</span>
                <Input value={filterValues.operatore} placeholder='Operatore' onChange={(e) => handelFilterChange("operatore", e.target.value)} />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Data caricamento</span>
                <RangePicker
                  value={filterValues.dateAddedRange}
                  style={{ width: "100%" }}
                  format={dateFormat}
                  placeholder={["Data inizio", 'Data fine']}
                  onChange={(dates) => handelFilterChange("dateAdded", dates)}
                  allowClear={false}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Data modifica</span>
                <RangePicker
                  value={filterValues.dateUpdatedRange}
                  style={{ width: "100%" }}
                  format={dateFormat}
                  placeholder={["Data inizio", 'Data fine']}
                  onChange={(dates) => handelFilterChange("dateUpdated", dates)}
                  allowClear={false}
                />
              </Space>
            </Col>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Batch</span>
                <Input value={filterValues.flux} placeholder='Batch' onChange={(e) => handelFilterChange("flux", e.target.value)} />
              </Space>
            </Col>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>File Comunicazione</span>
                <Input value={filterValues.fileCommunicazioneName} placeholder='File Comunicazione' onChange={(e) => handelFilterChange("fileCommunicazioneName", e.target.value)} />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Note Presenti</span>
                <Switch checked={filterValues.hasNotes} onChange={(checked) => handelFilterChange("hasNotes", checked)} />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Anomalie Presenti</span>
                <Switch checked={filterValues.hasAnomaly} onChange={(checked) => handelFilterChange("hasAnomaly", checked)} />
              </Space>
            </Col>

          </Row>
          <Divider />
          <Row gutter={{ lg: 24 }}>
            <Col className="gutter-row fliterButtons" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>

              <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
              <Button onClick={() => clearFilters()}> Rimuovi  </Button>
            </Col>
          </Row>
        </>
      )
    }
  ];

  const exportSelectedDocuments = () => {
    getSelectedDocuments();
  };

  const toggleCreateFluxModal = () => {
    setShowDocumentFluxModal(true);
    getUsersList();
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSelectPage = () => {
    setHasAllSelection(false);
    const selectedPageDocIds = documents.map(doc => doc.id);
    setSelectedRowKeys(selectedPageDocIds);
  };

  const handleSelectAll = () => {
    setHasAllSelection(true);
    const allDocumentIds = documents.map(doc => doc.id);
    setSelectedRowKeys(allDocumentIds);
  };

  const handleDeselectAll = () => {
    setSelectedRowKeys([]);
    setHasAllSelection(false);
  };

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
    columnWidth: "50px",
  };

  const hasSelected = selectedRowKeys.length > 0;
  const selectedRowsCount = selectedRowKeys.length;

  const items = (
    [
      {
        key: '1',
        label: (
          <Text onClick={handleSelectPage}>Seleziona pagina</Text>
        )
      },
      {
        key: '2',
        label: <Text onClick={handleSelectAll}>Seleziona tutto</Text>
      }
    ])

  const filterData = (values) => {
    setFilterValues(values);
    setPageNumber(1); // Reset to first page when applying new filters
  };

  return (
    <>
      {showDocumentFluxModal &&
        <CreateDocumentFlux
          showDocumentFluxModal={showDocumentFluxModal}
          handelModalClose={() => setShowDocumentFluxModal(false)}
          handelCreateFlux={handelCreateFlux}
          loadingButton={loadingFlux}
          operators={operatorUsers}
        />
      }

      <PageHeader title="FGAS" />

      <Row justify="center" align="top" gutter={[16, 16]} className='fgasDocuments'>
{/* 
        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Collapse
            size='small'
            defaultActiveKey={['1']}
            items={panelItems}
          />

        </Col> */}

        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Filters
            onFilterData={filterData}
            onResetData={clearFilters}
            filterValues={filterValues}
            filtersInitValues={filtersInitValues}
            totalDocNr={totalCountRecords}
            pageNumber={pageNumber}
            pageSize={tablePageSize}
          />
        </Col>

        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Card className="docListButtons">
            <Row justify="space-between" align="middle">
              <Col>
                <Space size="middle">
                  <Dropdown menu={{ items }}>
                    <Button type="default">Seleziona {`(${selectedRowsCount})`}<DownOutlined /></Button>
                  </Dropdown>
                  <Button type="default" onClick={handleDeselectAll}>Deseleziona tutto</Button>
                </Space>
              </Col>

              {group2Rights(currentUser) && (
                <Col>
                  <Space size="middle">
                    <Button type="primary" onClick={() => toggleCreateFluxModal()} icon={<PlusOutlined />}>Carica flusso</Button>
                    <Button type="primary" icon={<PlusOutlined />}><RouterLink to={menuLinks.fgas + "/new"}>Carica documento</RouterLink></Button>
                  </Space>
                </Col>
              )}
            </Row>
          </Card>

        </Col>


        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          {/* <Card style={{ width: '100%' }} className="docListTable"> */}
          <Card style={{ display: "inline-block", width: "100%" }} className="docListTable">
            <Table
              className='customTableRows'
              bordered
              rowClassName={(_, index) =>
                index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
              }
              loading={loadingData}
              dataSource={documents}
              columns={generateColumn()}
              rowKey={obj => obj.id}
              rowSelection={rowSelection}
              onChange={(pagination, filters, sorter) =>
                onPageOrOrderChange(pagination, filters, sorter)
              }
              pagination={{
                pageSize: tablePageSize,
                showSizeChanger: false,
                total: totalCountRecords || 0,
                current: pageNumber
              }}
              // tableLayout="fixed"
              style={{ width: "auto" }}
            />
            <Row gutter={{ lg: 24 }}>
              <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                <div className="doc-bottom-button-wrapper">
                  <Button type="primary" loading={loadingExcelDataExport} disabled={!hasSelected} onClick={getDocumentAttachmentsExportFiles} className='mr10'> Scarica {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
                  <Button type="primary" loading={loadingExcelDataExport} onClick={exportSelectedDocuments} disabled={!hasSelected} className='mr10'> Esporta {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

    </>

  );
}
export default FgasDocumentsList;